import React from "react";
import ReactDOM from "react-dom";

import * as axios from "axios";

// Init Sentry
// eslint-disable-next-line no-unused-vars
import Sentry from "./api/sentry";
// import { initRemoteConfig } from "./api/firebase/remote-config";
import App from "./App";
import AppBoost from "./AppBoost";
import AppIQ from "./AppIQ";
import AppKosmofi from "./AppKosmofi";
import "./generated.css";

// Set axios base URL
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

// Init Firebase RemoteConfig
// initRemoteConfig(); // temporarily disabled

const domain = window.location.hostname;

if (domain.endsWith("tomoboost.com")) {
  ReactDOM.render(<AppBoost />, document.getElementById("root"));
} else if (domain.endsWith("kosmofi.com")) {
  ReactDOM.render(<AppKosmofi />, document.getElementById("root"));
} else if (domain.endsWith("tomoiq.ai") || domain.endsWith("tomoiq.com")) {
  ReactDOM.render(<AppIQ />, document.getElementById("root"));
} else {
  ReactDOM.render(<App />, document.getElementById("root"));
}
